import { PayloadAction } from '@reduxjs/toolkit';

import { getLineItem } from '../../logic/line-item';
import { getQuantityBreak } from '../../logic/quantity-break';
import { WritableAutoConfiguratorState } from '../slice';

type Payload = {
  lineUuid: string;
  priceUuid?: string;
  isPending: boolean;
};

export function updateQuoteLineIsCreating(
  state: WritableAutoConfiguratorState,
  { payload: { lineUuid, priceUuid, isPending } }: PayloadAction<Payload>,
) {
  const quoteLine = getLineItem(state, lineUuid);
  quoteLine.isPending = isPending;

  if (priceUuid) {
    const quotePrice = getQuantityBreak(state, priceUuid);
    quotePrice.isPending = isPending;
  }
}
